import { SpenderSection } from './SpenderSection'
import { withSpenderSection } from './withSpenderSection'

const ConnectedSpenderSection = withSpenderSection(SpenderSection)
export { ConnectedSpenderSection as SpenderSection }
